var _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _g7, _path4, _g8, _g9, _g0, _g1, _g10, _g11, _path5, _path6, _g12, _g13, _rect, _rect2, _g14, _g15, _g16, _g17, _path7, _path8, _path9, _path0, _path1, _g18, _path10, _g19, _path11, _g20, _g21, _path12, _g22, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 309.665,
    height: 181.449,
    viewBox: "0 0 309.665 181.449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_15449",
    "data-name": "Group 15449",
    transform: "translate(8431.914 -19668.895)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-8431.914 19750.32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2459",
    "data-name": "Rectangle 2459",
    width: 309.664,
    height: 3.897,
    fill: "#00406d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8063",
    "data-name": "Path 8063",
    d: "M70.839,276.8v92.941h2.416L76.294,276.8Z",
    transform: "translate(-52.394 -274.005)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9737",
    "data-name": "Group 9737",
    transform: "translate(46.964 5.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8064",
    "data-name": "Path 8064",
    d: "M108.379,280.8v86.1h2.416l3.039-86.1Z",
    transform: "translate(-108.379 -280.8)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8065",
    "data-name": "Path 8065",
    d: "M108.379,280.8v86.1h2.416l3.039-86.1Z",
    transform: "translate(-108.379 -280.8)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8066",
    "data-name": "Path 8066",
    d: "M429.62,276.8v92.941h-2.408L424.165,276.8Z",
    transform: "translate(-137.301 -274.005)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9738",
    "data-name": "Group 9738",
    transform: "translate(258.353 5.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8067",
    "data-name": "Path 8067",
    d: "M392.09,280.8v86.1h-2.416l-3.039-86.1Z",
    transform: "translate(-386.635 -280.8)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8068",
    "data-name": "Path 8068",
    d: "M392.09,280.8v86.1h-2.416l-3.039-86.1Z",
    transform: "translate(-386.635 -280.8)",
    opacity: 0.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9745",
    "data-name": "Group 9745",
    transform: "translate(-8285.809 19731.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9743",
    "data-name": "Group 9743",
    transform: "translate(3.968)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2460",
    "data-name": "Rectangle 2460",
    width: 8.957,
    height: 18.196,
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2461",
    "data-name": "Rectangle 2461",
    width: 8.957,
    height: 18.196,
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9744",
    "data-name": "Group 9744",
    transform: "translate(0 14.878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8075",
    "data-name": "Path 8075",
    d: "M255.85,271.96H238.881l4.139-3.644h8.692Z",
    transform: "translate(-238.881 -268.316)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8076",
    "data-name": "Path 8076",
    d: "M255.85,271.96H238.881l4.139-3.644h8.692Z",
    transform: "translate(-238.881 -268.316)",
    fill: "#fff",
    opacity: 0.5
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9749",
    "data-name": "Group 9749",
    transform: "translate(-8273.951 19744.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9747",
    "data-name": "Group 9747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9746",
    "data-name": "Group 9746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8077",
    "data-name": "Path 8077",
    d: "M296.91,265.357H254.489l7.665,5.913h42.414Z",
    transform: "translate(-254.489 -265.357)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8078",
    "data-name": "Path 8078",
    d: "M296.91,265.357H254.489l7.665,5.913h42.414Z",
    transform: "translate(-254.489 -265.357)",
    fill: "#fff",
    opacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9748",
    "data-name": "Group 9748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8079",
    "data-name": "Path 8079",
    d: "M255.469,271.271l-.98-5.913,7.665,5.913Z",
    transform: "translate(-254.489 -265.357)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8080",
    "data-name": "Path 8080",
    d: "M255.469,271.271l-.98-5.913,7.665,5.913Z",
    transform: "translate(-254.489 -265.357)",
    opacity: 0.5
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9750",
    "data-name": "Group 9750",
    transform: "translate(-8317.65 19688.727)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2462",
    "data-name": "Rectangle 2462",
    width: 80.141,
    height: 50.277,
    rx: 1.928,
    fill: "#00406d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2463",
    "data-name": "Rectangle 2463",
    width: 74.238,
    height: 43.815,
    transform: "translate(2.911 3.141)",
    opacity: 0.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9753",
    "data-name": "Group 9753",
    transform: "translate(-8280.321 19700.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9751",
    "data-name": "Group 9751"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2464",
    "data-name": "Rectangle 2464",
    width: 37.461,
    height: 25.79,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2465",
    "data-name": "Rectangle 2465",
    width: 37.461,
    height: 2.362,
    fill: "#407bff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9769",
    "data-name": "Group 9769",
    transform: "translate(-8311.695 19695.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9754",
    "data-name": "Group 9754"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2466",
    "data-name": "Rectangle 2466",
    width: 2.536,
    height: 2.536,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2467",
    "data-name": "Rectangle 2467",
    width: 2.536,
    height: 2.536,
    transform: "translate(0 6.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2468",
    "data-name": "Rectangle 2468",
    width: 2.536,
    height: 2.536,
    transform: "translate(0 13.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2469",
    "data-name": "Rectangle 2469",
    width: 2.536,
    height: 2.536,
    transform: "translate(0 19.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2470",
    "data-name": "Rectangle 2470",
    width: 2.536,
    height: 2.536,
    transform: "translate(0 26.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2471",
    "data-name": "Rectangle 2471",
    width: 2.536,
    height: 2.536,
    transform: "translate(0 32.826)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9755",
    "data-name": "Group 9755",
    transform: "translate(4.946 0.571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2472",
    "data-name": "Rectangle 2472",
    width: 10.11,
    height: 0.76,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9756",
    "data-name": "Group 9756",
    transform: "translate(7.302 7.154)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2473",
    "data-name": "Rectangle 2473",
    width: 3.601,
    height: 0.76,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9757",
    "data-name": "Group 9757",
    transform: "translate(22.975 14.538)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2474",
    "data-name": "Rectangle 2474",
    width: 3.601,
    height: 0.76,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9758",
    "data-name": "Group 9758",
    transform: "translate(7.302 20.398)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2475",
    "data-name": "Rectangle 2475",
    width: 3.601,
    height: 0.76,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9759",
    "data-name": "Group 9759",
    transform: "translate(12.495 20.398)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2476",
    "data-name": "Rectangle 2476",
    width: 3.601,
    height: 0.76,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9760",
    "data-name": "Group 9760",
    transform: "translate(12.495 14.538)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2477",
    "data-name": "Rectangle 2477",
    width: 9.202,
    height: 0.76,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9761",
    "data-name": "Group 9761",
    transform: "translate(17.855 20.398)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2478",
    "data-name": "Rectangle 2478",
    width: 6.058,
    height: 0.76,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9762",
    "data-name": "Group 9762",
    transform: "translate(17.835 34.474)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2479",
    "data-name": "Rectangle 2479",
    width: 3.601,
    height: 0.76,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9763",
    "data-name": "Group 9763",
    transform: "translate(23.027 34.474)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2480",
    "data-name": "Rectangle 2480",
    width: 3.601,
    height: 0.76,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9764",
    "data-name": "Group 9764",
    transform: "translate(28.388 34.474)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2481",
    "data-name": "Rectangle 2481",
    width: 2.012,
    height: 0.76,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9765",
    "data-name": "Group 9765",
    transform: "translate(12.708 7.154)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2482",
    "data-name": "Rectangle 2482",
    width: 11.205,
    height: 0.76,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9766",
    "data-name": "Group 9766",
    transform: "translate(12.495 27.255)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2483",
    "data-name": "Rectangle 2483",
    width: 3.601,
    height: 0.76,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9767",
    "data-name": "Group 9767",
    transform: "translate(17.3 27.255)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2484",
    "data-name": "Rectangle 2484",
    width: 2.082,
    height: 0.76,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9768",
    "data-name": "Group 9768",
    transform: "translate(20.974 27.255)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2485",
    "data-name": "Rectangle 2485",
    width: 5.88,
    height: 0.76,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9789",
    "data-name": "Group 9789",
    transform: "translate(-8280.929 19668.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9773",
    "data-name": "Group 9773",
    transform: "translate(33.965 89.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9772",
    "data-name": "Group 9772",
    transform: "translate(1.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9771",
    "data-name": "Group 9771",
    transform: "translate(0 65.556)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8084",
    "data-name": "Path 8084",
    d: "M297.415,388.93l-5.538-1.656,1.291-13.576,5.538,1.656Z",
    transform: "translate(-291.877 -370.64)",
    fill: "#7f3e3b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8085",
    "data-name": "Path 8085",
    d: "M299.488,371.321l-5.538-1.648-.722,7.6,5.6,1.041Z",
    transform: "translate(-292.202 -369.672)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8086",
    "data-name": "Path 8086",
    d: "M330.2,283.379s-38.083,3.213-37.149,19.752c.766,13.539,2.773,9.859-1.17,50.114l9.58.529s9.746-32.927,8.432-46.008c10.734,0,35.31.942,38.881-8.744a43.056,43.056,0,0,0,2.545-15.346Z",
    transform: "translate(-291.877 -283.379)",
    fill: "#407bff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8087",
    "data-name": "Path 8087",
    d: "M302.534,376.051l-12.52-2.142.205-5.538,12.96,2.879Z",
    transform: "translate(-290.014 -303.803)",
    fill: "#263238"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9775",
    "data-name": "Group 9775",
    transform: "translate(23.844 167.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8088",
    "data-name": "Path 8088",
    d: "M287.658,388.563l6.4,1.266a.481.481,0,0,1,.365.538l-.532,6.048a1.068,1.068,0,0,1-1.17,1c-2.218-.485-3.267-.843-6.078-1.4-1.732-.34-5.69-1.175-8.1-1.444s-2.12-3.087-1.079-3.23c4.68-.619,7.339-1.373,9.154-2.548A1.423,1.423,0,0,1,287.658,388.563Z",
    transform: "translate(-276.692 -386.988)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9774",
    "data-name": "Group 9774",
    transform: "translate(6.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8089",
    "data-name": "Path 8089",
    d: "M286.985,389.519a7.259,7.259,0,0,0,1.519.046.121.121,0,0,0,.114-.084.144.144,0,0,0,0-.144c-.16-.16-1.6-1.519-2.332-1.367a.48.48,0,0,0-.372.319.762.762,0,0,0,.046.76A1.588,1.588,0,0,0,286.985,389.519Zm1.223-.205c-1.056,0-1.8-.122-2.021-.433a.48.48,0,0,1,0-.486.245.245,0,0,1,.175-.167C286.749,388.144,287.615,388.782,288.208,389.314Z",
    transform: "translate(-285.833 -386.847)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8090",
    "data-name": "Path 8090",
    d: "M289.029,389.213h.061a.15.15,0,0,0,.091-.1c0-.068.418-1.686-.068-2.332a.647.647,0,0,0-.532-.281.511.511,0,0,0-.547.319,2.985,2.985,0,0,0,.927,2.363A.1.1,0,0,0,289.029,389.213Zm-.4-2.439a.4.4,0,0,1,.266.167,2.975,2.975,0,0,1,.068,1.869,2.728,2.728,0,0,1-.684-1.892c0-.076.084-.16.281-.152Z",
    transform: "translate(-286.35 -386.496)",
    fill: "#407bff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9778",
    "data-name": "Group 9778",
    transform: "translate(10.956 89.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9776",
    "data-name": "Group 9776",
    transform: "translate(0 67.236)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8091",
    "data-name": "Path 8091",
    d: "M265,391.665l-5.272-2.37,3.647-13.006,5.272,2.37Z",
    transform: "translate(-259.727 -372.942)",
    fill: "#7f3e3b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8092",
    "data-name": "Path 8092",
    d: "M270.378,374.253l-5.272-2.37-1.876,6.708,5.272,2.37Z",
    transform: "translate(-260.569 -371.883)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9777",
    "data-name": "Group 9777",
    transform: "translate(0.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8093",
    "data-name": "Path 8093",
    d: "M311.7,283.379c-.251,0-42.695,4.368-42.748,18.764-.091,23.809-6.89,51.1-6.89,51.1l8.388,4.156s14.607-29.587,14.387-48.146c11.676-3.35,41.882,2.279,45.452-7.4,2.925-7.916,1.345-18.476,1.345-18.476Z",
    transform: "translate(-260.543 -283.379)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8094",
    "data-name": "Path 8094",
    d: "M271.307,379.344l-11.243-5.06.9-4.6,11.859,4.095Z",
    transform: "translate(-260.064 -304.118)",
    fill: "#263238"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9780",
    "data-name": "Group 9780",
    transform: "translate(0 166.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8095",
    "data-name": "Path 8095",
    d: "M256.785,387.649l6.412,1.332a.532.532,0,0,1,.357.592l-.5,6.649c-.086.722-.605,1.216-1.162,1.105h0c-2.218-.513-3.267-.908-6.078-1.49-1.732-.355-6.45-1.5-8.828-2.121s-1.846-3.65-.76-3.67c4.7-.068,7.749-.838,9.557-2.15A1.287,1.287,0,0,1,256.785,387.649Z",
    transform: "translate(-245.305 -386.178)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9779",
    "data-name": "Group 9779",
    transform: "translate(7.216 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8096",
    "data-name": "Path 8096",
    d: "M256.435,389.171a7.2,7.2,0,0,0,1.251-.863.137.137,0,0,0,.044-.145.128.128,0,0,0-.111-.088c-.223-.035-2.184-.29-2.692.277a.511.511,0,0,0-.1.479.76.76,0,0,0,.484.587A1.587,1.587,0,0,0,256.435,389.171Zm.858-.887c-.826.647-1.517.962-1.88.85a.485.485,0,0,1-.29-.4.226.226,0,0,1,.048-.232A3.767,3.767,0,0,1,257.293,388.284Z",
    transform: "translate(-254.803 -386.264)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8097",
    "data-name": "Path 8097",
    d: "M257.893,387.763l.055-.04a.114.114,0,0,0,.014-.123c-.04-.055-.665-1.611-1.438-1.847a.659.659,0,0,0-.591.091.517.517,0,0,0-.25.586c.163.624,1.475,1.3,2.147,1.35A.154.154,0,0,0,257.893,387.763Zm-1.766-1.731a.4.4,0,0,1,.315-.032,3.034,3.034,0,0,1,1.171,1.469,2.71,2.71,0,0,1-1.677-1.119c-.045-.062-.027-.178.138-.288Z",
    transform: "translate(-255.011 -385.719)",
    fill: "#407bff"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9781",
    "data-name": "Group 9781",
    transform: "translate(47.657 43.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8098",
    "data-name": "Path 8098",
    d: "M339.764,222.916c1.117,2.4,2.036,4.71,2.955,7.111s1.732,4.8,2.484,7.263,1.405,4.984,1.93,7.6a39.634,39.634,0,0,1,.851,8.258,17.019,17.019,0,0,1-.722,4.809,10.806,10.806,0,0,1-1.269,2.7,8.635,8.635,0,0,1-1.086,1.322l-.327.319c-.182.152-.38.319-.57.448a6.067,6.067,0,0,1-1.018.562,8.022,8.022,0,0,1-1.641.524,10.7,10.7,0,0,1-1.345.2,18.423,18.423,0,0,1-2.317,0,32.52,32.52,0,0,1-4.087-.456,77.423,77.423,0,0,1-14.746-4.224l1.1-4.186c4.824.577,9.747,1.193,14.389,1.405,1.155,0,2.279.053,3.327,0a9.835,9.835,0,0,0,1.39-.175c.38-.068.706-.205.593-.2a.885.885,0,0,0-.213.106,1.275,1.275,0,0,0-.213.16h0a1.186,1.186,0,0,0,.068-.129,3.539,3.539,0,0,0,.228-.676,10.654,10.654,0,0,0,.205-2.537,33.623,33.623,0,0,0-.965-6.45c-.517-2.279-1.185-4.5-1.914-6.754s-1.519-4.513-2.385-6.761-1.778-4.5-2.674-6.625Z",
    transform: "translate(-310.637 -222.916)",
    fill: "#7f3e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8099",
    "data-name": "Path 8099",
    d: "M320.673,265.97l-5.037-2.834-2.53,5.455s5.888,2.454,7.126.919Z",
    transform: "translate(-309.255 -232.581)",
    fill: "#7f3e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8100",
    "data-name": "Path 8100",
    d: "M310.339,264.157l-2.3,3.646,3.852.737,2.53-5.455Z",
    transform: "translate(-308.037 -232.569)",
    fill: "#7f3e3b"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9783",
    "data-name": "Group 9783",
    transform: "translate(12.02 44.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8101",
    "data-name": "Path 8101",
    d: "M316.727,227.562c-.965,2.423-1.975,4.74-3.039,7.088s-2.127,4.657-3.251,6.966a133.669,133.669,0,0,1-7.6,13.674c-.76,1.124-1.519,2.241-2.37,3.358-.425.562-.9,1.117-1.4,1.687-.274.289-.494.555-.813.851l-.456.441-.258.243a6.454,6.454,0,0,1-2.492,1.322,11.092,11.092,0,0,1-1.474.311,15.387,15.387,0,0,1-2.446.1,31.653,31.653,0,0,1-4.209-.418,77.293,77.293,0,0,1-15.057-4.269l1.109-4.194c4.915.593,9.937,1.223,14.662,1.421a32.276,32.276,0,0,0,3.343-.046,8.458,8.458,0,0,0,1.329-.213,1.753,1.753,0,0,0,.41-.152c.046,0,0-.053-.205.076a.976.976,0,0,0-.205.152s.053-.068.076-.091l.213-.236c.137-.137.3-.365.463-.547.311-.4.631-.82.95-1.284.631-.9,1.246-1.907,1.854-2.925,1.215-2.036,2.347-4.2,3.457-6.389s2.173-4.421,3.221-6.67c2.089-4.482,4.133-9.078,6.078-13.6Z",
    transform: "translate(-263.708 -224.219)",
    fill: "#7f3e3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9782",
    "data-name": "Group 9782",
    transform: "translate(0 28.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8102",
    "data-name": "Path 8102",
    d: "M273.771,264.9l-5.044-2.871-2.53,5.455s5.888,2.461,7.134.927Z",
    transform: "translate(-262.345 -262.029)",
    fill: "#7f3e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8103",
    "data-name": "Path 8103",
    d: "M263.436,263.107l-2.309,3.639,3.852.737,2.53-5.455Z",
    transform: "translate(-261.127 -262.029)",
    fill: "#7f3e3b"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9785",
    "data-name": "Group 9785",
    transform: "translate(59.797 5.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8104",
    "data-name": "Path 8104",
    d: "M344.572,193.139l-3.221,3.73-4.916,5.085c.1.25.237.576.376.921a9.136,9.136,0,0,1,.656,2.941c.107,2.038-.088,3.762-3.3,5.145,0,0-3.373,4.406,4.649,3.183s9.23-5.386,9.23-5.386C344.489,206.228,344.291,197.819,344.572,193.139Z",
    transform: "translate(-326.286 -177.658)",
    fill: "#7f3e3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9784",
    "data-name": "Group 9784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8105",
    "data-name": "Path 8105",
    d: "M326.18,187.32c0,.5-.251.927-.585.942s-.6-.38-.608-.881.258-.927.585-.942S326.172,186.819,326.18,187.32Z",
    transform: "translate(-324.25 -176.047)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8106",
    "data-name": "Path 8106",
    d: "M328.017,184.538a.292.292,0,0,1-.243-.137,2.467,2.467,0,0,0-1.838-1.17.3.3,0,0,1-.289-.3.3.3,0,0,1,.3-.289h0a3.038,3.038,0,0,1,2.325,1.443.3.3,0,0,1-.091.41A.333.333,0,0,1,328.017,184.538Z",
    transform: "translate(-324.409 -175.134)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8107",
    "data-name": "Path 8107",
    d: "M325.764,187.969a16.112,16.112,0,0,1-1.747,3.89,2.432,2.432,0,0,0,2.066.152Z",
    transform: "translate(-324.017 -176.415)",
    fill: "#630f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8108",
    "data-name": "Path 8108",
    d: "M343.093,181.5c-.3,6.2-.16,9.876-3.236,13.158a8.075,8.075,0,0,1-13.842-3.578c-1.4-5.493-.669-14.708,5.318-17.473a8.159,8.159,0,0,1,11.76,7.893Z",
    transform: "translate(-324.352 -172.76)",
    fill: "#7f3e3b"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9787",
    "data-name": "Group 9787",
    transform: "translate(56.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9786",
    "data-name": "Group 9786",
    transform: "translate(7.27 11.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8109",
    "data-name": "Path 8109",
    d: "M346.878,185.587a22.959,22.959,0,0,1-4.026,7.217l-8.068,1.519s-6.374-2.667-4.672-7.058c-1.079-.912-.676-3.73.084-5.28a3.288,3.288,0,0,0,4.307-.114,2.951,2.951,0,0,0,4.672.387,3.114,3.114,0,0,0,4.908-.79,2.789,2.789,0,0,0,3.251-.213c.038-.038.076-.068.114-.106A11.089,11.089,0,0,1,346.878,185.587Z",
    transform: "translate(-329.452 -181.15)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8110",
    "data-name": "Path 8110",
    d: "M346.878,185.587a22.959,22.959,0,0,1-4.026,7.217l-8.068,1.519s-6.374-2.667-4.672-7.058c-1.079-.912-.676-3.73.084-5.28a3.288,3.288,0,0,0,4.307-.114,2.951,2.951,0,0,0,4.672.387,3.114,3.114,0,0,0,4.908-.79,2.789,2.789,0,0,0,3.251-.213c.038-.038.076-.068.114-.106A11.089,11.089,0,0,1,346.878,185.587Z",
    transform: "translate(-329.452 -181.15)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8111",
    "data-name": "Path 8111",
    d: "M345.74,174.417a2.8,2.8,0,0,1-.593,3.077c-.038.038-.076.068-.114.106a2.789,2.789,0,0,1-3.251.213,3.114,3.114,0,0,1-4.908.79,2.951,2.951,0,0,1-4.672-.387,3.288,3.288,0,0,1-4.307.114,2.623,2.623,0,0,1-.76-.942,1.774,1.774,0,0,1-.106-.251,1.8,1.8,0,0,1-.213.205,2.345,2.345,0,0,1-2.7.16,2.3,2.3,0,0,1-.972-2.044,2.1,2.1,0,0,1,.084-.486,1.315,1.315,0,0,1-.228.311,1.9,1.9,0,0,1-2.7-.068,2.351,2.351,0,0,1,.752-3.312,2.8,2.8,0,0,1,1.428-.38,3.659,3.659,0,0,1,2.18.752,2.246,2.246,0,0,1,3.6-2.682,1.982,1.982,0,0,1,.813-2.059,3.209,3.209,0,0,1,3.647.934s1.17-2.826,3.191-2.507c.441.061,2.515.98,2.461,1.724a.315.315,0,0,1-.038.144,1.206,1.206,0,0,1,.1-.167,2.251,2.251,0,0,1,1.945-.919,6.528,6.528,0,0,1,2.34.623c1.573.646,3.244,1.367,4.156,2.8S347.374,173.962,345.74,174.417Z",
    transform: "translate(-319.882 -165.937)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8112",
    "data-name": "Path 8112",
    d: "M333.563,188.933a7.275,7.275,0,0,1-2.006,4.056c-1.375,1.315-2.545,0-2.56-2,0-1.808.676-4.671,2.279-5.2S333.859,186.965,333.563,188.933Z",
    transform: "translate(-322.073 -170.684)",
    fill: "#7f3e3b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9788",
    "data-name": "Group 9788",
    transform: "translate(58.68 35.403)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8113",
    "data-name": "Path 8113",
    d: "M356.308,215.578c-.57-1.519-3.229-3.039-4.862-3.039h-1.079a59.022,59.022,0,0,0-6.511.418,115.861,115.861,0,0,0-12.915,2.173c-1.96.516-3.852,1.17-5.356,1.732-1.914.76-3.039,1.269-3.039,1.269s2.1,13.966,3.183,27.84c.6,7.72.354,15.387.547,20.659h32.408c1.117-6.336.94-11.862,1.032-23.3C359.77,236.459,358.655,221.83,356.308,215.578Z",
    transform: "translate(-322.547 -212.539)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8114",
    "data-name": "Path 8114",
    d: "M325.815,242.637c.243,2.91.494,5.964.76,9.018,3.8-5.546,5.9-20.718,5.9-20.718Z",
    transform: "translate(-323.332 -216.96)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8115",
    "data-name": "Path 8115",
    d: "M317.228,220.766c-4.642,2.613-9.191,15.987-9.191,15.987l10.627,8.019c4.057-3.836,9.99-13.355,10.636-17.161C330.341,221.769,324.666,216.6,317.228,220.766Z",
    transform: "translate(-260.38 -178.75)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9797",
    "data-name": "Group 9797",
    transform: "translate(-8258.494 19698.625)"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9790",
    "data-name": "Group 9790",
    transform: "translate(18.633 144.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8116",
    "data-name": "Path 8116",
    d: "M305.972,399.39a3.3,3.3,0,1,1-3.3-3.3,3.3,3.3,0,0,1,3.3,3.3Z",
    transform: "translate(-299.363 -395.029)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8117",
    "data-name": "Path 8117",
    d: "M372.953,399.39a3.3,3.3,0,1,0,3.3-3.3,3.3,3.3,0,0,0-3.3,3.3Z",
    transform: "translate(-317.047 -395.029)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8118",
    "data-name": "Path 8118",
    d: "M336.274,398a3.3,3.3,0,1,0,3.3-3.3,3.305,3.305,0,0,0-3.3,3.3Z",
    transform: "translate(-308.233 -394.695)",
    fill: "#263238"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9791",
    "data-name": "Group 9791",
    transform: "translate(15.026 136.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8119",
    "data-name": "Path 8119",
    d: "M328.541,391.654v-6.389h-9.466a30.225,30.225,0,0,0-5.538.517l-17.626,3.425a1.6,1.6,0,0,0,.357,3.176Z",
    transform: "translate(-294.615 -385.265)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8120",
    "data-name": "Path 8120",
    d: "M339.273,391.654v-6.389h9.473a30.09,30.09,0,0,1,5.538.517l19.809,3.167a1.6,1.6,0,0,1-.357,3.176Z",
    transform: "translate(-305.347 -385.265)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9792",
    "data-name": "Group 9792",
    transform: "translate(43.087 94.027)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2486",
    "data-name": "Rectangle 2486",
    width: 11.722,
    height: 29.256,
    transform: "translate(0 13.614)",
    fill: "#263238"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2487",
    "data-name": "Rectangle 2487",
    width: 8.357,
    height: 13.606,
    transform: "translate(1.687)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8121",
    "data-name": "Path 8121",
    d: "M333.773,332.841l8.357,2.1v-6.1h-8.357Z",
    transform: "translate(-332.087 -328.845)",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9796",
    "data-name": "Group 9796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9794",
    "data-name": "Group 9794",
    transform: "translate(0.023)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2488",
    "data-name": "Rectangle 2488",
    width: 4.247,
    height: 18.119,
    transform: "translate(17.667 63.245)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8122",
    "data-name": "Path 8122",
    d: "M331.739,299.1V220.336a10.345,10.345,0,0,1,3.53-7.784l5.614-4.915a10.349,10.349,0,0,1,6.814-2.562h20.281l9.91,10.545V299.1Z",
    transform: "translate(-288.534 -205.075)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8123",
    "data-name": "Path 8123",
    d: "M287.877,308.785h46.265v15.239h-53.8a5.469,5.469,0,0,1-4.71-8.257h0A14.222,14.222,0,0,1,287.877,308.785Z",
    transform: "translate(-274.867 -229.997)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8124",
    "data-name": "Path 8124",
    d: "M364.225,215.624v83.482H280.34a5.475,5.475,0,0,1-4.71-8.258,14.211,14.211,0,0,1,12.223-6.982h23.3a6.918,6.918,0,0,0,6.918-6.919V220.335a10.32,10.32,0,0,1,3.533-7.779l5.614-4.915a10.314,10.314,0,0,1,6.814-2.56h20.276Z",
    transform: "translate(-274.868 -205.076)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9793",
    "data-name": "Group 9793",
    transform: "translate(49.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8125",
    "data-name": "Path 8125",
    d: "M340.624,299.1V220.336a10.343,10.343,0,0,1,3.531-7.784l5.614-4.915a10.348,10.348,0,0,1,6.814-2.562H372.39a10.344,10.344,0,0,1,7.538,3.261l4.039,4.3a10.345,10.345,0,0,1,2.807,7.085v71.5a7.886,7.886,0,0,1-7.886,7.886Z",
    transform: "translate(-340.624 -205.075)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8126",
    "data-name": "Path 8126",
    d: "M340.624,299.1V220.336a10.343,10.343,0,0,1,3.531-7.784l5.614-4.915a10.348,10.348,0,0,1,6.814-2.562H372.39a10.344,10.344,0,0,1,7.538,3.261l4.039,4.3a10.345,10.345,0,0,1,2.807,7.085v71.5a7.886,7.886,0,0,1-7.886,7.886Z",
    transform: "translate(-340.624 -205.075)",
    fill: "#fff",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9795",
    "data-name": "Group 9795",
    transform: "translate(0 58.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8127",
    "data-name": "Path 8127",
    d: "M309.073,292.5a43.8,43.8,0,0,0-28.868,0,4.1,4.1,0,0,1-5.082-1.936h0c-.866-1.831.3-4.2,2.651-5.03a51.108,51.108,0,0,1,33.715,0c2.355.821,3.517,3.2,2.651,5.03h0A4.11,4.11,0,0,1,309.073,292.5Z",
    transform: "translate(-274.836 -282.67)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8128",
    "data-name": "Path 8128",
    d: "M309.073,292.5a43.8,43.8,0,0,0-28.868,0,4.1,4.1,0,0,1-5.082-1.936h0c-.866-1.831.3-4.2,2.651-5.03a51.108,51.108,0,0,1,33.715,0c2.355.821,3.517,3.2,2.651,5.03h0A4.11,4.11,0,0,1,309.073,292.5Z",
    transform: "translate(-274.836 -282.67)",
    fill: "#fff",
    opacity: 0.7
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(-8388.258 19674.535)"
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9800",
    "data-name": "Group 9800",
    transform: "translate(24.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9799",
    "data-name": "Group 9799",
    transform: "translate(3.123 5.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8129",
    "data-name": "Path 8129",
    d: "M164.469,196.189c-.16.448-.046.9.251,1s.661-.175.813-.623.046-.9-.243-1S164.629,195.733,164.469,196.189Z",
    transform: "translate(-146.48 -184.072)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8130",
    "data-name": "Path 8130",
    d: "M163.918,197.005a17.121,17.121,0,0,0,.813,4.6,2.758,2.758,0,0,1-2.279-.349Z",
    transform: "translate(-146.012 -184.424)",
    fill: "#a02724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8131",
    "data-name": "Path 8131",
    d: "M163.477,192.162a.275.275,0,0,0,.175,0,2.219,2.219,0,0,1,2,.3.281.281,0,0,0,.365-.425,2.787,2.787,0,0,0-2.522-.418.281.281,0,0,0,0,.532Z",
    transform: "translate(-146.217 -183.098)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8132",
    "data-name": "Path 8132",
    d: "M142.141,198.575c.851,4.323,1.694,12.246-1.329,15.133,0,0,1.185,4.383,9.223,4.383,8.835,0,4.224-4.383,4.224-4.383-4.824-1.155-4.048-4.733-3.2-8.091Z",
    transform: "translate(-140.812 -184.802)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8133",
    "data-name": "Path 8133",
    d: "M144.554,186.378c-1.58,5.652-2.8,8.881-.988,12.687,2.712,5.736,12.189,6.479,14.776-.086,1.968-6.045,3.912-12.434-.737-16.513a8.007,8.007,0,0,0-13.051,3.912Z",
    transform: "translate(-141.257 -180.445)",
    fill: "#b55b52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8134",
    "data-name": "Path 8134",
    d: "M136.995,186.555a9.116,9.116,0,0,1,.523-6.211c1.039-1.851,3.558-2.985,5.386-1.905a8.888,8.888,0,1,1,12.6,11.43q.632-2.33,1.266-4.66a9.065,9.065,0,0,1-3.238,5.506q.367-2.329.732-4.659a7.141,7.141,0,0,1-3.45,5.358q.443-1.632.886-3.264a28.6,28.6,0,0,1-1.713,4.367c-.746.869-1.246,6.581-3.864,6.761C137.177,201.07,137.956,191.419,136.995,186.555Z",
    transform: "translate(-136.701 -173.363)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8135",
    "data-name": "Path 8135",
    d: "M152.987,193.619a6.685,6.685,0,0,0,.927,4.156c1.01,1.626,2.492,1,3.039-.661.486-1.519.539-4.14-.866-5.2S153.2,191.871,152.987,193.619Z",
    transform: "translate(-140.606 -177.719)",
    fill: "#b55b52"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9802",
    "data-name": "Group 9802",
    transform: "translate(0 51.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8136",
    "data-name": "Path 8136",
    d: "M119.818,260.295c-.968-.321-5.486-2.645-6.206-2.23,2.087-5.324,3.387-6.141,4.336-9.53a5.215,5.215,0,0,0-1.01-4.943c-1.335-1.788-1.8-2.695-4.024-2.474-3.054,5.107-6.9,11.408-8.4,17.164-.507,1.938-.874,3.409.28,5.047a6.225,6.225,0,0,0,4.654,2.183c4.235.38,10.516-.4,10.436-2.913C119.828,261.015,119.818,260.295,119.818,260.295Z",
    transform: "translate(-104.026 -241.085)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9801",
    "data-name": "Group 9801",
    transform: "translate(13.939 17.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8137",
    "data-name": "Path 8137",
    d: "M123.508,265.752l3.59-1.165-.319,6.482s-2.874.1-4.4-1.819Z",
    transform: "translate(-122.374 -264.486)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8138",
    "data-name": "Path 8138",
    d: "M132.974,264.454l-.514,5.345-4.287,1.238.319-6.482Z",
    transform: "translate(-123.767 -264.454)",
    fill: "#b55b52"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9807",
    "data-name": "Group 9807",
    transform: "translate(47.324 31.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8139",
    "data-name": "Path 8139",
    d: "M183.256,262.267s-5-3.92-11.569-16.877q-1.461-2.718-2.8-5.479c-.894-1.859-1.753-3.677-2.572-5.629l7.761-3.345c1.6,3.482,4.089,7.074,5.851,10.531s5.922,11.643,6.443,12.407c.259.393.539.719.808,1.083l.4.533-5.007,5.788Z",
    transform: "translate(-166.32 -218.413)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9804",
    "data-name": "Group 9804",
    transform: "translate(15.889 7.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9803",
    "data-name": "Group 9803",
    transform: "translate(5.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8140",
    "data-name": "Path 8140",
    d: "M196.54,236.182l-1.555-1.854-.719-2.775,4.688-4.355a20.313,20.313,0,0,1,1.927,2.9,1.485,1.485,0,0,1,.163.749l-.191,4.88Z",
    transform: "translate(-194.266 -225.359)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8141",
    "data-name": "Path 8141",
    d: "M194.334,227.966l3.508-3.189,1.11,1.862-4.686,4.333Z",
    transform: "translate(-194.266 -224.777)",
    fill: "#b55b52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8142",
    "data-name": "Path 8142",
    d: "M194.919,236.955c.123-.522.231.5.575.09,1.037-1.241,2.542-1.376,3.438-.03s.129,14.9-1.3,19.15c-.951,2.822-1.458,5.073-3.89,6.789a5.9,5.9,0,0,1-3.417,1.226,3.24,3.24,0,0,1-2.965-1.832c-.722-1.772,1.959-8.152,2.919-10.21C193.281,245.686,193.48,243.078,194.919,236.955Z",
    transform: "translate(-187.235 -227.489)",
    fill: "#b55b52"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8146",
    "data-name": "Path 8146",
    d: "M123.278,219.868c-5.546,1.269-13.746,18.547-13.746,18.547l11.129,7.6a124.746,124.746,0,0,0,8.659-14.319C132.61,224.81,128.945,218.569,123.278,219.868Z",
    transform: "translate(-105.349 -184.497)",
    fill: "#d0d4d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9808",
    "data-name": "Group 9808",
    transform: "translate(13.446 31.664)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8147",
    "data-name": "Path 8147",
    d: "M138.058,219.17c-.638-1.39-1.329-2.978.106-3.472,1.588-.547,10.279-1.109,13.272-.084A3.084,3.084,0,0,1,153.6,219.4l-.016.059Z",
    transform: "translate(-125.473 -215.043)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8148",
    "data-name": "Path 8148",
    d: "M129.637,233.058l-7.911,14.892,1.866,1.273s3.584-4.99,6.046-9.305Z",
    transform: "translate(-121.726 -219.372)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8149",
    "data-name": "Path 8149",
    d: "M161.151,227.118c1.2,6.065-1.6,20.485-1.573,44.042H127.953c-.209-4.761,3.254-16.034-1.048-38.491-.139-.728-.2-13.026.526-13.154a82.709,82.709,0,0,1,9.258-1.092,115.053,115.053,0,0,1,13.447,0,34.311,34.311,0,0,1,6.529,1.974C159.5,221.417,160.566,224.159,161.151,227.118Z",
    transform: "translate(-122.95 -215.808)",
    fill: "#00406d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8150",
    "data-name": "Path 8150",
    d: "M160.995,237.88a36.908,36.908,0,0,0,7.361,15.456c.129-2.834.412-5.793.4-8.064Z",
    transform: "translate(-131.163 -220.531)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8151",
    "data-name": "Path 8151",
    d: "M158.022,226.457c-.76,5.6,10.256,19.9,10.256,19.9l11.084-7.6s-3.077-7.878-8.25-13.044C165.216,219.787,158.888,220.365,158.022,226.457Z",
    transform: "translate(-116.993 -184.947)",
    fill: "#d0d4d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9809",
    "data-name": "Group 9809",
    transform: "translate(77.257 151.734)"
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8152",
    "data-name": "Path 8152",
    d: "M205.722,386.792h5.91l1.345-13.7h-5.91Z",
    transform: "translate(-205.722 -373.095)",
    fill: "#b55b52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8153",
    "data-name": "Path 8153",
    d: "M213.065,374.194l-.684,7.057h-5.918l.691-7.057Z",
    transform: "translate(-205.9 -373.359)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811",
    transform: "translate(53.942 151.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8154",
    "data-name": "Path 8154",
    d: "M175.032,386.792h5.91l2.97-13.7H178Z",
    transform: "translate(-175.032 -373.095)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9810",
    "data-name": "Group 9810",
    transform: "translate(1.308 0.73)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8155",
    "data-name": "Path 8155",
    d: "M178.288,374.056h5.91l-1.535,7.058h-5.91Z",
    transform: "translate(-176.753 -374.056)"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8156",
    "data-name": "Path 8156",
    d: "M211.363,387.629h-6.45a.576.576,0,0,0-.509.531l-1.17,6.765a1.156,1.156,0,0,0,.637,1.337.683.683,0,0,0,.213.03c2.325-.049,5.69-.226,8.615-.226,3.426,0,6.381.236,10.393.236,2.431,0,3.107-3.176,2.089-3.461-4.627-1.308-8.4-1.446-12.4-4.641A2.33,2.33,0,0,0,211.363,387.629Z",
    transform: "translate(-127.861 -224.853)",
    fill: "#263238"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812",
    transform: "translate(86.287 162.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8157",
    "data-name": "Path 8157",
    d: "M219.518,390.073c.76,0,1.519-.106,1.74-.448a.54.54,0,0,0,0-.615.758.758,0,0,0-.441-.327c-.988-.266-3.039.912-3.138.965a.129.129,0,0,0-.068.144.145.145,0,0,0,.106.114A10.374,10.374,0,0,0,219.518,390.073Zm.942-1.147a.916.916,0,0,1,.266,0,.394.394,0,0,1,.273.2c.1.175.068.258,0,.3-.273.387-1.77.4-2.872.236A6.328,6.328,0,0,1,220.46,388.926Z",
    transform: "translate(-217.608 -387.228)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8158",
    "data-name": "Path 8158",
    d: "M217.733,389.458h.061c.714-.319,2.127-1.6,2.013-2.279,0-.159-.137-.349-.517-.395a1.032,1.032,0,0,0-.76.243,3.951,3.951,0,0,0-.919,2.279.143.143,0,0,0,.053.129A.177.177,0,0,0,217.733,389.458Zm1.443-2.393h.084c.251,0,.266.129.274.16.068.4-.9,1.405-1.626,1.838a3.263,3.263,0,0,1,.76-1.816A.757.757,0,0,1,219.177,387.065Z",
    transform: "translate(-217.608 -386.78)",
    fill: "#407bff"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8159",
    "data-name": "Path 8159",
    d: "M180.727,387.629h-6.64a.57.57,0,0,0-.5.531l-1.17,6.765a1.162,1.162,0,0,0,.672,1.342.705.705,0,0,0,.194.025c2.317-.049,3.449-.226,6.366-.226,1.8,0,4.1.236,6.587.236s2.8-3.176,1.785-3.461c-4.558-1.288-4.87-3.068-6.328-4.769A1.261,1.261,0,0,0,180.727,387.629Z",
    transform: "translate(-120.456 -224.853)",
    fill: "#263238"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9813",
    "data-name": "Group 9813",
    transform: "translate(62.093 162.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8160",
    "data-name": "Path 8160",
    d: "M187.41,391.072a1.91,1.91,0,0,0,1.421-.387.563.563,0,0,0,0-.661.646.646,0,0,0-.441-.327c-.866-.205-2.5.912-2.568.957a.159.159,0,0,0-.061.144.137.137,0,0,0,.106.106A7.311,7.311,0,0,0,187.41,391.072Zm.76-1.124a.562.562,0,0,1,.167,0,.349.349,0,0,1,.258.182c.129.236.053.327,0,.365-.251.327-1.459.334-2.347.19a4.556,4.556,0,0,1,1.907-.737Z",
    transform: "translate(-185.76 -388.255)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8161",
    "data-name": "Path 8161",
    d: "M185.906,390.464h.061c.615-.334,1.8-1.626,1.671-2.279a.456.456,0,0,0-.448-.372.756.756,0,0,0-.593.182c-.684.562-.828,2.279-.836,2.34a.153.153,0,0,0,.068.129A.129.129,0,0,0,185.906,390.464Zm1.193-2.393h.061c.182,0,.2.106.205.144.076.388-.684,1.367-1.291,1.831a3.349,3.349,0,0,1,.7-1.854.5.5,0,0,1,.327-.122Z",
    transform: "translate(-185.761 -387.807)",
    fill: "#407bff"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9815",
    "data-name": "Group 9815",
    transform: "translate(17.189 87.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9814",
    "data-name": "Group 9814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8162",
    "data-name": "Path 8162",
    d: "M150.058,287.915s27.994,11.556,33.782,20.443c-3.441,22.592-9.618,48.332-9.618,48.332H163.695a207.886,207.886,0,0,1,2.726-33.245c1.519-27.615-48.178.958-38.522-35.53Z",
    transform: "translate(-126.652 -287.915)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8163",
    "data-name": "Path 8163",
    d: "M179.148,312.98a51.523,51.523,0,0,0-5.846.673l-6.135.944a92.345,92.345,0,0,0,10,7.307c2.118,1.34,4.423,2.632,6.929,2.644,2.807.014,10.434-3.6,9.169-7.346C191.978,313.411,182.34,312.856,179.148,312.98Z",
    transform: "translate(-136.388 -293.935)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8164",
    "data-name": "Path 8164",
    d: "M160.966,287.915s25.876,3.337,40.141,11.46c4.392,2.5,3.777,10.532,3.663,15.821A125,125,0,0,1,196.7,356.69H187.92s.448-14.335.152-37.468c-.091-6.936-14.092-9.223-27.774-10.028a31.147,31.147,0,0,1-26.771-19.045l-.934-2.233Z",
    transform: "translate(-128.08 -287.915)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8165",
    "data-name": "Path 8165",
    d: "M215.681,375.345c.046,0-.57,4.155-.57,4.155H202.956l-.334-3.707Z",
    transform: "translate(-144.909 -308.925)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8166",
    "data-name": "Path 8166",
    d: "M186.414,375.345c.046,0-1.117,4.155-1.117,4.155H173.142l.22-3.707Z",
    transform: "translate(-137.824 -308.925)",
    fill: "#407bff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9819",
    "data-name": "Group 9819",
    transform: "translate(9.212 104.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9816",
    "data-name": "Group 9816",
    transform: "translate(13.62 2.852)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8167",
    "data-name": "Path 8167",
    d: "M144.363,315.355l-8.709,64.2-1.573-.215,6.722-64.47Z",
    transform: "translate(-134.08 -314.869)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8168",
    "data-name": "Path 8168",
    d: "M144.051,318.532l-8.4,61.9-1.573-.215,6.432-61.693Z",
    transform: "translate(-134.08 -315.748)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9817",
    "data-name": "Group 9817",
    transform: "translate(5.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8169",
    "data-name": "Path 8169",
    d: "M172.322,316.752h-49.38a5.637,5.637,0,0,1,5.637-5.637h38.106a5.637,5.637,0,0,1,5.637,5.637Z",
    transform: "translate(-122.942 -311.115)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8170",
    "data-name": "Path 8170",
    d: "M172.322,316.752h-49.38a5.637,5.637,0,0,1,5.637-5.637h38.106a5.637,5.637,0,0,1,5.637,5.637Z",
    transform: "translate(-122.942 -311.115)",
    fill: "#fff",
    opacity: 0.7
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8171",
    "data-name": "Path 8171",
    d: "M123.6,318.525l-7.445,62.416h1.6l9.443-62.416Z",
    transform: "translate(-116.152 -312.896)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9818",
    "data-name": "Group 9818",
    transform: "translate(48.666 5.629)"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8172",
    "data-name": "Path 8172",
    d: "M183.8,318.525l7.445,62.416h-1.6l-9.435-62.416Z",
    transform: "translate(-180.212 -318.525)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8173",
    "data-name": "Path 8173",
    d: "M183.8,318.525l7.445,62.416h-1.6l-9.435-62.416Z",
    transform: "translate(-180.212 -318.525)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8174",
    "data-name": "Path 8174",
    d: "M170.685,318.525l.144,62.416h-1.588l-2.15-62.416Z",
    transform: "translate(-128.393 -312.896)",
    fill: "#407bff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.eced3d35f7d9c07fa6c4e064c4b0de71.svg";
export { ForwardRef as ReactComponent };